import {
  CHANGE_THEME,
  CHANGE_THEME_FAILED,
  CHANGE_THEME_SUCCESS,
  REQUEST_THEME,
  REQUEST_THEME_FAILED,
  REQUEST_THEME_SUCCESS,
} from '../constants';

export type ActionType<T> = {
  type: string;
  payload: T;
};

export type QueryType = {
  theme: {
    kind: string;
  };
};

export type PayloadType = {
  id: string;
  query: QueryType;
};

export function requestTheme(payload: string): ActionType<string> {
  return {
    payload,
    type: REQUEST_THEME,
  };
}
export function requestThemeSuccess(payload: QueryType): ActionType<QueryType> {
  return {
    payload,
    type: REQUEST_THEME_SUCCESS,
  };
}
export function requestThemeFailed(payload: QueryType): ActionType<QueryType> {
  return {
    payload,
    type: REQUEST_THEME_FAILED,
  };
}
export function changeTheme(payload: PayloadType): ActionType<PayloadType> {
  return {
    payload,
    type: CHANGE_THEME,
  };
}
export function changeThemeSuccess(payload: QueryType): ActionType<QueryType> {
  return {
    payload,
    type: CHANGE_THEME_SUCCESS,
  };
}
export function changeThemeFailed(payload: QueryType): ActionType<QueryType> {
  return {
    payload,
    type: CHANGE_THEME_FAILED,
  };
}
